import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'RELATIONSHIP_MANAGER_LIST_GET_ALL',
  GET_ALL_SUCCESS: 'RELATIONSHIP_MANAGER_LIST_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'RELATIONSHIP_MANAGER_LIST_GET_ALL_FAILURE',
  POST: 'RELATIONSHIP_MANAGER_POST',
  POST_SUCCESS: 'RELATIONSHIP_MANAGER_POST_SUCCESS',
  POST_FAILURE: 'RELATIONSHIP_MANAGER_POST_FAILURE',
  PATCH: 'RELATIONSHIP_MANAGER_BULK_UPDATE_PATCH',
  PATCH_SUCCESS: 'RELATIONSHIP_MANAGER_BULK_UPDATE_SUCCESS',
  PATCH_FAILURE: 'RELATIONSHIP_MANAGER_BULK_UPDATE_FAILURE',

  INVALIDATE_LIST: 'RELATIONSHIP_MANAGER_INVALIDATE_ALL',
};

export const getAll = actions.getAll(
  query => `${BASE_URL}/parents/relationship-manager?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post(() => `${BASE_URL}/parents/relationship-manager/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const patch = actions.patch(
  () => `${BASE_URL}/parents/relationship-manager/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
  {
    headers: {
      encType: 'multipart/form-data',
    },
  },
  true,
);

export const invalidateList = params => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_LIST,
    payload: { params },
  });
};
